import { l } from '@manychat/manyui'

import { IBlock, IDefaultBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { BlockType } from 'common/builder/constants/BlockType'

export function getConditionNodeNextStep({
  blocks,
  conditionsLength,
}: {
  blocks: IBlock[]
  conditionsLength: number
}) {
  const defaultBlock = blocks.find(
    (block): block is IDefaultBlock => block.type === BlockType.DEFAULT,
  )

  if (!defaultBlock) {
    return null
  }

  const shouldShowNextStep = defaultBlock.targetId || conditionsLength > 0

  if (!shouldShowNextStep) {
    return null
  }

  return new FlowChartNextStepBuilder(defaultBlock.id)
    .withLabel(l.translate(`The contact doesn't match any\n of these conditions`))
    .withColor(sharedStyles.Colors.DANGER)
    .build()
}
